import React from 'react';

import QuizContext from './context';

/**
 * This is the engine for a quiz component.
 * @param {Object} props
 * @param {string} props.examId
 * @param {string} props.courseAssetId
 * @param {Object} props.metadata - contains data of the quiz which is passed from outside
 * @param {string} props.metadata.title
 * @param {string} props.metadata.description
 * @param {number} props.metadata.maxAttempts - total attempts allowed for this quiz
 * */

const QuizProvider = (props) => {
  const {
    examId,
    courseAssetId,
    metadata,
    variant,
    openCourseReviewModal,
    isLastSubsectionInCourse,
    onExitClassroom,
    children,
  } = props;
  const [error, setError] = React.useState(null);
  const [timeSpent, setTimeSpent] = React.useState(null);
  return (
    <QuizContext.Provider
      value={{
        metadata,
        examId,
        courseAssetId,
        variant,
        error,
        setError,
        timeSpent,
        setTimeSpent,
        openCourseReviewModal,
        isLastSubsectionInCourse,
        onExitClassroom,
      }}
    >
      {children}
    </QuizContext.Provider>
  );
};

export default QuizProvider;
